import { AxiosError } from 'axios';
import { logger } from '../../utils/logger';

export class ApiErrorHandler {
  static handle(error: unknown): never {
    if (error instanceof AxiosError) {
      const errorMessage = {
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        message: error.message,
        url: error.config?.url,
      };

      // Handle specific error cases
      switch (error.response?.status) {
        case 401:
          logger.error('Authentication failed:', errorMessage);
          throw new Error('Authentication failed. Please log in again.');
        case 403:
          logger.error('Authorization failed:', errorMessage);
          throw new Error('You do not have permission to access this resource.');
        case 404:
          logger.error('Resource not found:', errorMessage);
          throw new Error('The requested resource was not found.');
        case 429:
          logger.error('Rate limit exceeded:', errorMessage);
          throw new Error('Too many requests. Please try again later.');
        default:
          logger.error('API Error:', errorMessage);
          const serverMessage =
            error.response?.data?.error?.message || error.response?.data?.message || error.message;
          throw new Error(serverMessage);
      }
    }

    if (error instanceof Error) {
      logger.error('Application Error:', error);
      throw error;
    }

    logger.error('Unknown Error:', error);
    throw new Error('An unexpected error occurred. Please try again.');
  }
}
